import { Reducer } from 'redux';
import { AuthTypes, AuthStateDistributor } from './types';
import { api } from '../../../services/api';

const INITIAL_STATE: AuthStateDistributor = {
  token: '',
  isLoggedIn: false,
};

const reducerDistributor: Reducer<AuthStateDistributor> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case AuthTypes.LOGIN_DISTRIBUTOR_SUCCESS: {
      const newState = { ...state };

      newState.isLoggedIn = true;
      newState.token = action.payload;

      return newState;
    }

    case AuthTypes.LOGIN_DISTRIBUTOR_FAILURE: {
      delete api.defaults.headers.Authorization;
      const newState = { ...INITIAL_STATE };
      return newState;
    }

    default:
      return state;
  }
};

export default reducerDistributor;
